exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../typography.pcss"), undefined);

// module
exports.push([module.id, ".NoData__noDataBodyText___1oTSP{text-align:left;padding-top:20px;padding-bottom:20px;border-bottom:1px solid #c2c2c2}.NoData__noDataBodyText___1oTSP p{font-size:16px;line-height:1.6}", ""]);

// exports
exports.locals = {
	"noDataBodyText": "NoData__noDataBodyText___1oTSP " + require("-!../../../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../typography.pcss").locals["heading"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/assets/NoData/NoData.pcss
// module id = 871
// module chunks = 0